const miscellaneous = {
    scrollTop: 'Défiler vers le Haut',
    scrollDown: 'faire défiler',
    siteBy: 'Site Web par',
}

export default miscellaneous
